import React from "react";
import Shell from 'components/layout/list/shell';
import Errors from 'components/error404';
import RedirectToDashBoard from 'routers/dashboard';
import { UserRoutes } from 'components/users/routes';
import PaymentRoutes from "components/subscription/router";

export function OrganizationRoutes() {

    console.log('MainRoutes');

    return [
        {
            path: '/',
            element: (<Shell />),
            loader: RedirectToDashBoard,
            errorElement: <Errors />,
        },
        {
            path: '/users',
            element: (<Shell />),
            errorElement: <Errors />,
            children: UserRoutes()
        },
        {
            path: '/payment',
            element: (<Shell />),
            errorElement: <Errors />,
            children: PaymentRoutes(),
        },
        {
            path: '*',
            element: (<Shell />),
            loader: RedirectToDashBoard,
            errorElement: RedirectToDashBoard,
        },
    ]
}

export default OrganizationRoutes;